"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, MessageSquareDashed } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useI18n } from "@llmgateway/i18n/react";
interface TempChatSwitcherProps {
  isTemporaryChat: boolean;
  onToggleTemporaryChat: () => void;
  isTemporaryChatToggleDisabled: boolean;
  hasTemporaryMessages: boolean;
}
export function TempChatSwitcher(t0) {
  const $ = _c(35);
  const {
    isTemporaryChat,
    onToggleTemporaryChat,
    isTemporaryChatToggleDisabled,
    hasTemporaryMessages
  } = t0;
  const {
    t
  } = useI18n();
  let t1;
  if ($[0] !== isTemporaryChat) {
    t1 = isTemporaryChat ? {
      scale: [1, 1.12, 1],
      rotate: [0, -8, 0]
    } : {
      scale: 1,
      rotate: 0
    };
    $[0] = isTemporaryChat;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.32,
      ease: "easeOut"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("playground.toggleTemporaryChat");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MessageSquareDashed className="size-4" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isTemporaryChat) {
    t5 = isTemporaryChat ? <motion.span key="temporary-check" initial={{
      scale: 0.45,
      opacity: 0,
      rotate: -18
    }} animate={{
      scale: 1,
      opacity: 1,
      rotate: 0
    }} exit={{
      scale: 0.45,
      opacity: 0,
      rotate: 18
    }} transition={{
      duration: 0.16,
      ease: "easeOut"
    }} className="absolute inset-0 flex items-center justify-center"><Check className="size-2.5 stroke-[3]" /></motion.span> : null;
    $[6] = isTemporaryChat;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="relative flex size-4 items-center justify-center">{t4}<AnimatePresence initial={false}>{t5}</AnimatePresence></span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isTemporaryChatToggleDisabled || $[11] !== onToggleTemporaryChat || $[12] !== t3 || $[13] !== t6) {
    t7 = <Button type="button" variant="ghost" size="icon-sm" onClick={onToggleTemporaryChat} disabled={isTemporaryChatToggleDisabled} className="bg-transparent" aria-label={t3}>{t6}</Button>;
    $[10] = isTemporaryChatToggleDisabled;
    $[11] = onToggleTemporaryChat;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <TooltipTrigger asChild={true}><motion.div animate={t1} transition={t2}>{t7}</motion.div></TooltipTrigger>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isTemporaryChat || $[19] !== t) {
    t9 = isTemporaryChat ? t("playground.temporaryChatOn") : t("playground.toggleTemporaryChat");
    $[18] = isTemporaryChat;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <TooltipContent>{t9}</TooltipContent>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <Tooltip>{t8}{t10}</Tooltip>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== hasTemporaryMessages || $[27] !== isTemporaryChat || $[28] !== t) {
    t12 = isTemporaryChat && hasTemporaryMessages ? <motion.span key="temporary-chat-label" initial={{
      opacity: 0,
      x: -6
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -6
    }} transition={{
      duration: 0.18
    }} className="text-xs text-muted-foreground hidden sm:inline">{t("playground.temporaryChat")}</motion.span> : null;
    $[26] = hasTemporaryMessages;
    $[27] = isTemporaryChat;
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = <AnimatePresence initial={false}>{t12}</AnimatePresence>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t13) {
    t14 = <>{t11}{t13}</>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}